import { h, Component } from 'preact';
import { configure } from '../../config';
import style from './style';
import cx from 'classnames';


/**
 * This wrapper places a div and an optional a tag if an href is supplied.
 */
function LogoWrapper({ children, trackingVars, href, ...props }) {
	return (
		<div class={cx(style.logo, props.class)}>
			{
				href ?
					(
						<a
							class={style.link}
							{...trackingVars}
							href={href}
						>
							{children}
						</a>
					) : children
			}

		</div>
	);
}

export class Logo extends Component {

	getLogo = (portalStaticOrigin, theme, size, client) => {
		if (!size || !client) return false;
		return {
			base: `${portalStaticOrigin}/images/${client}/logos/${theme}_${size}.png`,
			double: `${portalStaticOrigin}/images/${client}/logos/${theme}_${size}@2x.png`
		};
	};

	render({ theme, size, clientOverride, streamClient, portalStaticOrigin, link, onImageLoad, suppressLink, ...props }) {
		// In order to allow a custom image, logo can be either a key into predefined logos, or a URL to a logo image.
		let logoSrc =  this.getLogo(portalStaticOrigin, theme || 'light', size, clientOverride || streamClient);

		if (!logoSrc) return;

		return (
			<LogoWrapper
				class={cx(props.class)}
				href={link}
				suppressLink={suppressLink}
			>
				<span class={style.spacer} />
				<img
					srcset={`${logoSrc.base} 1x, ${logoSrc.double} 2x`}
					src={logoSrc.base}
				/>
			</LogoWrapper>
		);
	}
}

export default configure({
	portalStaticOrigin: 'portalStaticOrigin',
	clientOverride: 'logoConfig.clientOverride',
	streamClient: 'streamClient',
	link: 'logoConfig.link'
})(Logo);
